import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'form-button',
    imports: [MatButton],
    templateUrl: './form-button.html',
    styleUrl: './form-button.scss',
})
export class FormButton {
    public readonly label: InputSignal<string> = input();
    public readonly buttonType: InputSignal<'submit' | 'button' | 'reset'> = input('submit');
    public readonly type: InputSignal<'filled' | 'outlined' | 'elevated' | 'tonal'> = input('filled');
    public readonly wide: InputSignal<boolean> = input(false);
    public readonly disabled: InputSignal<boolean> = input(false);
    public readonly loading: InputSignal<boolean> = input(false);

    @Output()
    public readonly handlerClick = new EventEmitter<Event>();
}
